export default {
  falcon_component_ScanForApp_scanQRCode: 'Scan QR code',
  falcon_component_ScanForApp_scanQRCodeDescription:
    'Scan this code with your phone to download the free app',
  falcon_component_ScanForApp_scanQRCodeHelp: 'How do I scan this code?',
  falcon_component_ScanForApp_scanQRCodeHelpDescription:
    'To scan a QR code, you need a QR code reading app. Download one for free from your app store. Then just open the app and point your camera at the code.',
  falcon_component_ScanForApp_scanQRCodeClose: 'Close',
};
